import { render, staticRenderFns } from "./DevTable.vue?vue&type=template&id=ecaf377a&scoped=true&"
import script from "./DevTable.vue?vue&type=script&lang=js&"
export * from "./DevTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf377a",
  null
  
)

export default component.exports